"use strict";
// This fix error "global is not defined" in typed-array-length package
window.global = window;
